import { getState } from "app/StoreFactory";
import { useSelector } from "react-redux";

export function useGetPreferences(preferenceId) {
  const prefValueArr = useSelector((state) => state.preferences?.[preferenceId]);
  return prefValueArr;
}

export function useGetFirstPreference(preferenceId) {
  return useGetPreferences(preferenceId)?.[0];
}

export function useHasPreference(preferenceId, testValue) {
  return useGetPreferences(preferenceId)?.includes(testValue);
}

// unreactive equivalent
function getPreferences(preferenceId) {
  const prefValueArr = getState()?.preferences?.[preferenceId];
  return prefValueArr;
}

// unreactive equivalent
export function hasPreference(preferenceId, testValue) {
  return getPreferences(preferenceId)?.includes(testValue);
}
